import Partnership20 from '@carbon/icons-react/es/partnership/20';
import React, { FC } from 'react';
import { useTranslation } from 'hooks/use-translation';
import { CellWrapper, NameCell } from './component';

interface Props {
  onWrapperClick: () => void;
}

export const PartnerHeaderForUsersView: FC<Props> = ({ onWrapperClick }) => (
  <CellWrapper onClick={onWrapperClick}>
    <NameCell
      logo={<Partnership20 />}
      primaryText={useTranslation('partners')}
    />
  </CellWrapper>
);
